import { renderMultiProducts } from './MultiProducts';
import multiProductsSwitcher from './switcher';
export default async () => {
    renderMultiProducts();
    multiProductsSwitcher();
};
